import { TextStyle } from "pixi.js";
import { TextWithTime } from "./TextWithTime";

export class TextWithAdaptiveTime extends TextWithTime {
    private static readonly SECONDS_ON_DAY = 86400;

    public constructor(milliseconds: number, defaultText: string, completeTimeText?: string, style?: TextStyle) {
        super(
            milliseconds,
            defaultText,
            completeTimeText,
            style
        );
    }

    protected override formatText(): string {
        let seconds = Math.floor(this.milliseconds / TextWithAdaptiveTime.MILLISECONDS_ON_SECOND);
        const days = Math.floor(seconds / TextWithAdaptiveTime.SECONDS_ON_DAY);
        seconds -= days * TextWithAdaptiveTime.SECONDS_ON_DAY;
        const hours = Math.floor(seconds / TextWithAdaptiveTime.SECONDS_ON_HOURS);
        seconds -= hours * TextWithAdaptiveTime.SECONDS_ON_HOURS;
        if (days > 0) {
            return hours > 0 ? `${this.defaultText}${days}d ${hours.toString()}h` : `${this.defaultText}${days}d`;
        }
        const minutes = Math.floor(seconds / TextWithAdaptiveTime.SECONDS_ON_MINUTE);
        seconds -= minutes * TextWithAdaptiveTime.SECONDS_ON_MINUTE;
        if (hours > 0) {
            return minutes > 0 ? `${this.defaultText}${hours}h ${minutes.toString()}m` : `${this.defaultText}${hours}h`;
        }
        const remainingSeconds = seconds % TextWithAdaptiveTime.SECONDS_ON_MINUTE;
        if (minutes > 0) {
            return seconds > 0 ? `${this.defaultText}${minutes}m ${remainingSeconds.toString()}s` : `${this.defaultText}${minutes}m`;
        }
        return `${this.defaultText}${remainingSeconds}s`;
    }
}